import { PricingDetailsTableProps } from './PricingDetailsTable';


export const pricingPlanDetailsTablesData: (Omit<PricingDetailsTableProps, 'activePriceMode' | 'prices'>)[] = [
  {
    addPrices: true,
    title: 'CONNECT',
    rows: [
      {
        title: 'Hosts',
        subtitle: 'Hosts have full access to all settings. Add as many as you need.',
        plans: [
          { unlimited: true },
          { unlimited: true }
        ]
      },
      {
        title: 'Moderators',
        subtitle: 'Moderators have limited access related to moderating members, content, and features. Add as many as you need.',
        plans: [
          { unlimited: true },
          { unlimited: true }
        ]
      },
      {
        title: 'Members',
        subtitle: 'There’s no limit to how many members you can have in your Mighty Network.',
        mightyExclusive: true,
        plans: [
          { unlimited: true },
          { unlimited: true }
        ]
      },
      {
        title: 'Platforms',
        subtitle: 'Your Mighty Network will be available on the web and  through our iOS and Android apps.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'MESSAGE',
    rows: [
      {
        title: 'Group Messaging',
        subtitle: 'It’s easy for a few members to connect in a casual chat, directly from your Mighty Network.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: '1x1 Messaging',
        subtitle: 'Direct messaging is built-in to every Mighty Network.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Notify All Members',
        subtitle: 'Hosts can notify all members when they post something — you, not an algorithm, decide what your members see.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'LIVESTREAM',
    hint: '*Add more hours, attendees, and storage with Engagement Boosts',
    mightyExclusive: true,
    rows: [
      {
        title: 'Streaming Hours Per Month',
        subtitle: 'Go live directly from your Mighty Network.',
        plans: [
          { text: '2 Hours *' },
          { text: '4 Hours *' }
        ]
      },
      {
        title: 'Speakers Per Stream',
        subtitle: 'You can announce a new course, welcome new members, or just say hi.',
        plans: [
          { text: '1 Speaker *' },
          { text: '1 Speaker *' },
        ]
      },
      {
        title: 'Viewers Per Stream',
        subtitle: 'Members can view the livestream and join the chat with just one tap.',
        plans: [
          { text: '50 Viewers *' },
          { text: '100 Viewers *' }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'TEACH',
    mightyExclusive: true,
    rows: [
      {
        title: 'Courses',
        subtitle: 'Create a course in minutes — they can be content only, or include a community component.',
        plans: [
          {},
          { unlimited: true }
        ]
      },
      {
        title: 'Instructors & Moderators',
        subtitle: 'Instructors and moderators can edit course settings and/or lessons.',
        plans: [
          {},
          { unlimited: true }
        ]
      },
      {
        title: 'Dedicated Course Communities',
        subtitle: 'Members  learn faster and  stay longer when courses come with a dedicated community.',
        plans: [
          {},
          { unlimited: true }
        ]
      },
      {
        title: 'Native Video Instruction',
        subtitle: 'Quickly and easily add videos to your lessons.',
        plans: [
          {},
          { unlimited: true }
        ]
      },
      {
        title: 'Drip Course Content',
        subtitle: 'Release course content lesson-by-lesson.',
        plans: [
          {},
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'PUBLISH',
    rows: [
      {
        title: 'Native Video',
        mightyExclusive: true,
        subtitle: 'Record and upload video directly to your Mighty Network.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Long Form Articles',
        subtitle: 'Write and publish rich, compelling Articles with images, native video, and embeds.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Short Form Posts',
        subtitle: 'Quickly share a note, video, photo, or link with your Mighty Network.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Questions',
        subtitle: 'Pose a question in a way that catches the eye and solicits answers from your members.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Polls',
        subtitle: 'Multiple choice, percentage, and hot/cold polls are one of the simplest ways to get members talking.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Topics',
        subtitle: 'Organize conversations around the things your members care about.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Total Storage',
        subtitle: 'You can record livestreams and upload them along with other videos, photos, and documents. ',
        plans: [
          { text: '50 GB *' },
          { text: '150 GB *' }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'MEET',
    rows: [
      {
        title: 'Online Events',
        subtitle: 'Create one-off or recurring online events, track RSVPs, sync to calendars, and remind members.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'In-person Events',
        subtitle: 'The same  event feature works for gathering people together  IRL, too.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Zoom Integration',
        subtitle: 'This seamless integration works beautifully on web and mobile apps. Just sync your Zoom account and it’s ready.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Members Near You',
        subtitle: 'Unique to a Mighty Network, you (and your members) can quickly see who lives in the same area.',
        mightyExclusive: true,
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Member Categories',
        subtitle: 'Create the categories that matter to your members so they can quickly find others like them.',
        mightyExclusive: true,
        plans: [
          { checked: true },
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'CHARGE',
    rows: [
      {
        title: 'Charge for  Access to Your Mighty Network',
        subtitle: 'Your Mighty Network can be free or paid. Transaction fees exclude Stripe credit card  processing.',
        plans: [
          { text: '3% fee' },
          { text: '2% fee' }
        ]
      },
      {
        title: 'Charge for Online Courses',
        subtitle: 'Charge for an unlimited number of individual online courses  within your Mighty Network.',
        plans: [
          { text: '3% fee' },
          { text: '2% fee' }
        ]
      },
      {
        title: 'Charge for Groups',
        subtitle: 'Charge for an unlimited number of individual groups within your Mighty Network.',
        plans: [
          { text: '3% fee' },
          { text: '2% fee' }
        ]
      },
      {
        title: 'Charge for Bundles',
        mightyExclusive: true,
        subtitle: 'Bundle access to your Mighty Network with courses and/or groups  within it.',
        plans: [
          { text: '3% fee' },
          { text: '2% fee' }
        ]
      },
      {
        title: 'Choose Subscription or One-Time Payments',
        subtitle: 'Run individual or bundled annual or monthly subscriptions or charge an one-time fee.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Charge in Local Currencies',
        subtitle: 'Choose from over 100 local currencies for your paid plans.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'GROW',
    rows: [
      {
        title: 'Member Referrals',
        subtitle: 'Use the built-in ambassador program to encourage existing members to invite new ones.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Invite & Share',
        subtitle: 'Invite members one by one or via bulk upload. You can also create separate invite links for easy tracking.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'SEO',
        subtitle: 'If your Mighty Network is public, it’ll be scannable by search engines to help you grow organically.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'MANAGE',
    rows: [
      {
        title: 'Custom Domain',
        subtitle: 'Link an existing domain or buy a new one, right from your Mighty Network. Free for a limited time!',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Mighty Insights ™',
        mightyExclusive: true,
        subtitle: 'Premium analytics and benchmarks that tell you exactly what’s working, and for which members and cohorts.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Member Data Ownership',
        mightyExclusive: true,
        subtitle: 'You can export your member data, including email addresses.',
        plans: [
          {},
          { checked: true }
        ]
      },
      {
        title: 'API Integrations Via Zapier',
        subtitle: 'Connect your Mighty Network to thousands of other business tools.',
        plans: [
          {},
          { checked: true }
        ]
      },
      {
        title: 'Custom Navigation Links',
        subtitle: 'Feature a prominent link in your Mighty Network to an online shop, blog, social media profile...or anywhere!',
        plans: [
          {},
          { checked: true }
        ]
      },
      {
        title: 'Google Analytics Pixel',
        subtitle: 'Track traffic and behavior in your Mighty Network on the Google Analytics platform.',
        plans: [
          {},
          { checked: true }
        ]
      },
      {
        title: 'Facebook Ads Pixel',
        subtitle: 'Add this pixel if you want to run Facebook advertising campaigns that point to your Mighty Network.',
        plans: [
          {},
          { checked: true }
        ]
      },
      {
        title: 'Priority Support',
        subtitle: 'Access our Customer Advocacy team via the “Host Help” button, directly in your Mighty Network.',
        plans: [
          {},
          { checked: true }
        ]
      }
    ]
  },
  {
    addPrices: false,
    title: 'LEARN',
    rows: [
      {
        title: 'Mighty Community',
        subtitle: 'Find strategy and support by joining the largest community of creators and entrepreneurs.',
        plans: [
          { checked: true },
          { checked: true }
        ]
      },
      {
        title: 'Community Design ™ Accelerator',
        mightyExclusive: true,
        subtitle: 'For a one-time fee, get lifetime access to this  data-driven course in community engagement, pricing, and growth.',
        plans: [
          { text: '$149 ($200 off)' },
          { text: '$149 ($200 off)' }
        ]
      }
    ]
  }
]
